import React, { useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  useMediaQuery,
  Grid,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import { useTheme } from "@mui/material/styles";
import {
  InputText,
  InputPassword,
  setTitleCase,
} from "../../../components/template/partials";
import { useAccountUIContext } from "../AccountUIContext";
import useAuth from "../../../hooks/useAuth";

// inital values form
const initialValues = (autoComplate) => {
  return {
    username: autoComplate?.username ?? "",
    password: "",
  };
};

// form field validation schema
const validationSchema = Yup.object().shape({
  password: Yup.string().required("Password Baru wajib diisi!"),
});

export function AccountProfileResetPassword() {
  const accountUIContext = useAccountUIContext();
  const accountUIProps = useMemo(() => {
    return {
      data: accountUIContext.data,
      onHide: accountUIContext.onHide,
    };
  }, [accountUIContext]);
  const { data, onHide } = accountUIProps;
  const [isLoading, setLoading] = useState(false);
  const theme = useTheme();
  const location = useLocation();
  const showDialog = location.state?.showDialog ?? false;
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { chgPassword } = useAuth();

  const handleFormSubmit = async (values) => {
    setLoading(true);
    // send to backend
    try {
      await chgPassword(values);
      toast.success(setTitleCase("berhasil update password"));
    } catch (error) {
      toast.error(setTitleCase(error.response.data?.message));
    }
    setLoading(false);
    onHide();
  };

  return (
    <Dialog
      fullScreen={fullScreen}
      open={showDialog}
      onClose={onHide}
      aria-labelledby="responsive-dialog-account-profile-edit-title"
    >
      <DialogTitle id="responsive-dialog-account-profile-edit-title">
        Reset Password
      </DialogTitle>
      <Formik
        enableReinitialize
        onSubmit={handleFormSubmit}
        initialValues={initialValues(data)}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <form onSubmit={handleSubmit}>
            <DialogContent>
              <Grid container spacing={3}>
                <Grid item md={12} xs={12}>
                  <Field
                    component={InputText}
                    name="username"
                    label="Nama User"
                    size="small"
                    variant="outlined"
                    type="text"
                    fullWidth
                  />
                </Grid>
                <Grid item md={12} xs={12}>
                  <Field
                    component={InputPassword}
                    name="password"
                    label="New Password"
                    size="small"
                    variant="outlined"
                    fullWidth
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button
                autoFocus
                onClick={onHide}
                color="error"
                variant="contained"
              >
                Batal
              </Button>
              <LoadingButton
                autoFocus
                loading={isLoading}
                type="submit"
                color="primary"
                variant="contained"
              >
                Simpan
              </LoadingButton>
            </DialogActions>
          </form>
        )}
      </Formik>
    </Dialog>
  );
}
